
  export default {
    props: {
      field: { type: String, required: true },
      filterButton: { type: Boolean, default: false },
      inputAttrs: { type: Object, default () { return {}; } },
      modelName: { type: String, required: true },
      required: { type: Boolean, default: false },
      searchParams: { type: Object, default () { return {}; } },
      searchPath: { type: String, required: true }
    },
    data () {
      return {
        findExecuted: false,
        initialValue: null,
        isInitialRequest: true,
        isLoading: false,
        navIndex: 0,
        previousSearch: '',
        results: [],
        searchable: true,
        searchTerm: '',
        uuid: this.$uuid.v4()
      };
    },
    computed: {
      attribute: {
        get () {
          return this.$formGet(this.modelName, this.field);
        },
        set (value) {
          const h = {};
          h[this.field] = value;
          this.$formSet(this.modelName, h);
        }
      },
      keyField () {
        return this.inputAttrs['data-key-field'] || 'id';
      }
    },
    watch: {
      attribute (newValue, oldValue) {
        if (newValue && !oldValue && !this.findExecuted) {
          this.prepopulate();
        }
        this.checkRequired();
      },
      searchTerm (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue.length <= 0) {
            this.asyncFind(oldValue);
          }
        }
      }
    },
    beforeDestroy () {
      if (this.inputAttrs['data-do-reset']) {
        this.attribute = this.initialValue;
      }
    },
    mounted () {
      if (this.attribute) {
        this.prepopulate();
      }
      this.initialValue = this.attribute;
      this.checkRequired();
    },
    methods: {
      asyncFind (query) {
        this.isLoading = true;
        this.previousSearch = this.searchTerm;
        this.$api(this.searchPath, { ...this.searchParams, ...{ query } }).then(r => {
          this.results = r;
          this.isLoading = false;
          if (!this.findExecuted && this.results.length === 1) {
            this.attribute = { ...this.results[0] };
            this.searchTerm = this.results[0].name;
          } else {
            this.searchTerm = query;
          }
          this.findExecuted = true;
        });
      },
      checkRequired () {
        if (!this.attribute) {
          this.$el.querySelector('input').required = this.required;
          return;
        }
        const idValue = this.attribute[this.keyField];
        let required = this.required;
        if (this.keyField === 'id') {
          required = !(idValue >= 0);
        }
        if (this.keyField === 'alpha3') {
          required = !(typeof idValue === 'string' && idValue.length === 3);
        }
        this.$el.querySelector('input').required = required;
      },
      move (dir) {
        this.navIndex = Math.max(0, this.navIndex + dir);
      },
      prepopulate () {
        const q = (typeof this.attribute === 'object') ? this.attribute[this.keyField] : this.attribute;
        this.asyncFind(q || 'a');
      },
      search () {
        if (this.searchable && this.searchTerm.length > 2 && this.searchTerm !== this.previousSearch) {
          this.isLoading = true;
          this.previousSearch = this.searchTerm;
          this.$api(this.searchPath, { query: this.searchTerm }).then(r => {
            this.results = r;
            this.isLoading = false;
          });
        } else {
          this.results = [];
        }
      },
      select (result) {
        this.attribute = result.id;
        this.searchable = true;
        const el = this.$el.querySelector('input');
        if (el) el.blur();
      },
      setTerm (val) {
        this.searchTerm = val;
        this.search();
      }
    }
  };
